/**
 * Will return true if the message has a random number
 *
 * @param {string} message
 * @return {*}
 */
export const doesMessageHasRandomNumbers = (message: string) => {
    return /{{randomNumber\[(\d+),(\d+)\]}}/.test(message);
};
